import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=1fcf19c8&scoped=true&"
import script from "./Join.vue?vue&type=script&lang=js&"
export * from "./Join.vue?vue&type=script&lang=js&"
import style0 from "@/sass/join.scss?vue&type=style&index=0&id=1fcf19c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcf19c8",
  null
  
)

export default component.exports